<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-10">
            <page-loading v-if="!billing"></page-loading>
            <template v-else>
                <org-unit-billing-details
                    v-show="hash === 'billing-details' || !hash"
                    :teamId="props.teamId"
                    :orgUnitId="props.orgUnitId"
                    :billing="billing"
                    :isAdminOrOwner="isAdminOrOwner"
                />

                <org-unit-proforma-invoices
                    v-if="billing.is_billable"
                    v-show="hash === 'proforma-invoices'"
                    :teamId="props.teamId"
                    :orgUnitId="props.orgUnitId"
                    :paymentTermsDays="billing.payment_terms_days"
                />

                <org-unit-historical-invoices
                    v-show="hash === 'historical-invoices'"
                    :teamId="props.teamId"
                    :orgUnitId="props.orgUnitId"
                />
            </template>
        </div>
    </page-container>
</template>

<script setup>
import OrgUnitBillingDetails from '~/components/settings/teams/org-units/billing/OrgUnitBillingDetails.vue';
import OrgUnitProformaInvoices from './OrgUnitProformaInvoices.vue';
import OrgUnitHistoricalInvoices from './OrgUnitHistoricalInvoices.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import SettingsSidebar from '../menus/SettingsSidebar.vue';
import { ref, onMounted } from 'vue';
import { orgUnitBillingClient } from '~/services';
import { useSettingsHash } from '~/composables/useSettingsHash';

const { hash, content } = useSettingsHash();

const billing = ref(null);

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const isAdminOrOwner = Spark.isAdminOrOwner || ['admin', 'owner'].includes(Spark.roleOnCurrentOrgUnit);

const getBillingDetails = async () => {
    try {
        const response = await orgUnitBillingClient.getBillingDetails(props.teamId, props.orgUnitId);
        billing.value = response.data;
    } catch (error) {
        console.error('Failed to fetch billing details:', error);
    }
};

onMounted(() => {
    getBillingDetails();
});
</script>
